import useUrlState from '@ahooksjs/use-url-state'
import { DatePicker } from 'antd'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'
const { RangePicker } = DatePicker

interface DashboardRangePickerProps {
  startDate?: string
  endDate?: string
}

/**
 * 1. 快速选择： 上一周，过去4周，当前月，本季度，上个季度
 * 2. 传递参数需要是默认值
 * @param startDate
 * @param endDate
 * @returns
 */
export const DashboardRangePicker: React.FC<DashboardRangePickerProps> = ({ startDate, endDate }) => {
  const { t } = useTranslation()

  const [range, setRange] = React.useState([
    new URLSearchParams(window.location.search).get('startDate') ||
      (startDate && moment(startDate).format('YYYY-MM-DD')) ||
      moment().startOf('month').startOf('isoWeek').format('YYYY-MM-DD'),
    new URLSearchParams(window.location.search).get('endDate') ||
      (endDate && moment(endDate).format('YYYY-MM-DD')) ||
      moment().endOf('month').endOf('isoWeek').format('YYYY-MM-DD'),
  ])
  const [state, setState] = useUrlState(
    { startDate: range[0], endDate: range[1] },
    {
      navigateMode: 'replace',
    }
  )

  React.useEffect(() => {
    setState({ ...state, startDate: range[0], endDate: range[1] })
  }, [range])

  const Friday = 5 as const
  const Wednesday = 3 as const
  return (
    <div className='dashboard-range-picker'>
      <RangePicker
        getPopupContainer={(trigger) => trigger.parentElement || document.body}
        value={range.map((r) => moment(r)) as any}
        allowEmpty={[false, false]}
        picker='week'
        ranges={{
          // 上一周，过去4周，当前月，本季度，上个季度
          [t('上一周')]: [moment().subtract(1, 'w').startOf('week'), moment().subtract(1, 'w').endOf('week')],
          [t('过去4周')]: [moment().subtract(4, 'w').startOf('week'), moment().subtract(1, 'w').endOf('week')],
          [t('当前月')]: [moment().startOf('month'), moment().endOf('month')],
          [t('本季度')]: () => {
            const isStartLessThanFriday = moment().startOf('quarter').isoWeekday() < Friday
            const startDate = isStartLessThanFriday
              ? moment().startOf('quarter').startOf('week')
              : moment().startOf('quarter').add(1, 'week').startOf('week')
            const isEndMoreThanWednesday = moment().endOf('quarter').isoWeekday() > Wednesday
            const endDate = isEndMoreThanWednesday
              ? moment().endOf('quarter').endOf('week')
              : moment().endOf('quarter').subtract(1, 'week').endOf('week')
            return [startDate, endDate]
          },
          [t('上个季度')]: () => {
            const isStartLessThanFriday = moment().subtract(1, 'Q').startOf('quarter').isoWeekday() < Friday
            const startDate = isStartLessThanFriday
              ? moment().subtract(1, 'Q').startOf('quarter').startOf('week')
              : moment().subtract(1, 'Q').startOf('quarter').add(1, 'week').startOf('week')
            const isEndMoreThanWednesday = moment().subtract(1, 'Q').endOf('quarter').isoWeekday() > Wednesday
            const endDate = isEndMoreThanWednesday
              ? moment().subtract(1, 'Q').endOf('quarter').endOf('week')
              : moment().subtract(1, 'Q').endOf('quarter').subtract(1, 'week').endOf('week')
            return [startDate, endDate]
          },
        }}
        allowClear={false}
        onChange={(_, dateStrings) => {
          if (dateStrings) {
            const startWeek = dateStrings[0]
            const endWeek = dateStrings[1]
            const [startYear, startWeekNumber] = startWeek.split('-')
            const [endYear, endWeekNumber] = endWeek.split('-')
            const startDate = moment()
              .isoWeekYear(Number(startYear))
              .isoWeek(Number(startWeekNumber.replace(/[^0-9]/g, '')))
              .startOf('isoWeek')
            const endDate = moment()
              .isoWeekYear(Number(endYear))
              .isoWeek(Number(endWeekNumber.replace(/[^0-9]/g, '')))
              .endOf('isoWeek')
            setRange([startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')])
          }
        }}
      />
      <span className='ml-2'>{range.map((r) => moment(r).format('YYYY/MM/DD')).join(' - ')}</span>
    </div>
  )
}
